import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import {MANDATORY_SUPER_PROPERTIES} from '@adsk/bim360-analytics-sdk-js';
import AdminLayout from '@adsk/bim360-matrix-react-admin-layout';
import {scrollTo} from '@adsk/bim360-matrix-react-helpers';
import {AdminPageTabIds} from '../../constants/issues-admin';
import IssuesPermissionsAdminContainer from './issues-permissions/IssuesPermissionsAdminContainer';
import IssueTypesAdminContainer from './issue-types/IssueTypesAdminContainer';
import IssueAttributesAdminContainer from './issue-attributes/IssueAttributesAdminContainer';
import IssueRootCausesAdminContainer from './issues-rootcauses/IssueRootCausesAdminContainer';
import ProjectSetupInProgressPlaceholder from '../common/ProjectSetupInProgressPlaceholder';

class IssuesAdmin extends Component {
  constructor(props) {
    super(props);

    this.tabs = this.getTabsList();

    this.state = {
      pageContainerRef: undefined
    };

    this._scrollPageDown = this._scrollPageDown.bind(this);
    this.setRefIfNeeded = this.setRefIfNeeded.bind(this);
    this.getSelectedTab = this.getSelectedTab.bind(this);
    this.onTabSelect = this.onTabSelect.bind(this);
  }

  componentWillMount() {
    this.props.registerAnalyticsMandatorySuperProps({
      [MANDATORY_SUPER_PROPERTIES.FEATURE_MODULE]: 'Issues'
    });
  }

  getTabsList() {
    const issuesAdminPermissionsTab = {
      name: () => i18n.t('issuesAdmin.permissionsTab'),
      id: AdminPageTabIds.ISSUES_PERMISSIONS
    };
    const issuesAdminIssueTypesTab = {
      name: () => i18n.t('issuesAdmin.issueTypesTab'),
      id: AdminPageTabIds.ISSUE_TYPES
    };
    const issuesAdminRootCausesTab = {
      name: () => i18n.t('issuesAdmin.rootCausesTab'),
      id: AdminPageTabIds.ISSUE_ROOT_CAUSES
    };
    const issuesAdminIssueAttributesTab = {
      name: () => i18n.t('issuesAdmin.issueAttributesTab'),
      id: AdminPageTabIds.ISSUE_ATTRIBUTES
    };

    return [
      issuesAdminPermissionsTab,
      issuesAdminIssueTypesTab,
      issuesAdminRootCausesTab,
      issuesAdminIssueAttributesTab
    ];
  }

  getTabStripProps = () => ({
    tabs: this.tabs,
    onTabChange: this.onTabSelect,
    canClickSelectedTab: false,
    selectedTab: this.getSelectedTab(),
    theme: 'default'
  });

  getSelectedTab() {
    return this.tabs.find(tab => tab.id === this.props.adminTabId);
  }

  onTabSelect(tab) {
    this.props.changeLocationAction(`/admin/issues/${tab.id}`);
  }

  renderSelectedTab() {
    switch (this.props.adminTabId) {
      case AdminPageTabIds.ISSUES_PERMISSIONS: {
        return <IssuesPermissionsAdminContainer container={this.state.pageContainerRef} />;
      }
      case AdminPageTabIds.ISSUE_TYPES:
        return <IssueTypesAdminContainer scrollDown={this._scrollPageDown} />;
      case AdminPageTabIds.ISSUE_ROOT_CAUSES:
        return <IssueRootCausesAdminContainer scrollDown={this._scrollPageDown} />;
      case AdminPageTabIds.ISSUE_ATTRIBUTES:
        return <IssueAttributesAdminContainer scrollDown={this._scrollPageDown} />;
      default:
        return null;
    }
  }

  /**
   * Scrolls page down
   * @param offset - The offset to scroll to.
   * @param speed - The scroll speed.
   * @param scrollToBottom - Default is the bottom of the page..
   **/
  _scrollPageDown({offset = 0, speed = 0.5, scrollToBottom = true} = {}) {
    offset += scrollToBottom ? this.state.pageContainerRef.scrollHeight : this.state.pageContainerRef.scrollTop;
    scrollTo(this.state.pageContainerRef, offset, speed);
  }

  setRefIfNeeded(ref) {
    if (!this.state.pageContainerRef) {
      this.setState({pageContainerRef: ref});
    }
  }

  render() {
    if (this.props.shouldShowProjectSetupInProgressPlaceholder) {
      return <ProjectSetupInProgressPlaceholder />;
    }

    const tabStripProps = this.getTabStripProps();

    return (
      <AdminLayout tabStripProps={tabStripProps} className="IssuesAdmin" contentClassName="IssuesAdmin__content">
        <div className="IssuesAdmin__service" ref={this.setRefIfNeeded}>
          {this.renderSelectedTab()}
        </div>
      </AdminLayout>
    );
  }
}

IssuesAdmin.propTypes = {
  adminTabId: PropTypes.string.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  registerAnalyticsMandatorySuperProps: PropTypes.func.isRequired,
  shouldShowProjectSetupInProgressPlaceholder: PropTypes.bool.isRequired
};

IssuesAdmin.displayName = 'IssuesAdmin';

export default IssuesAdmin;
